import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackComponent from "../../../../components/BackComponent/BackComponent";
import Modal from "../../../../components/Modal/Modal";
import { useAuthentication } from "../../../hooks/useAuthentication";
import { OsobniRadGrupaValidationSchema } from "./Schema";
import styles from "./Styles.module.css";
import {
  handleInputChange,
  handleUnesiSateClick,
  osobniRadGrupeRadionice,
  postData,
  uloge,
} from "./utils";

function OsobniRadGrupa({ userEvidentionID }) {
  const navigate = useNavigate();
  const { authToken } = useAuthentication();
  const fullName = localStorage.getItem("evidentionFullName");
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    image: "",
    description: "",
    buttons: [],
  });
  const [formData, setFormData] = useState({
    vrstaRadionicePrograma: "",
    uloga: "",
    dateGrupa: "",
    brojSati: "",
  });
  const otherInfo = JSON.stringify(
    postData("therapist_therapy_manual", formData)
  );
  const [errors, setErrors] = useState({});
  return (
    <div className={styles.wrapper}>
      <BackComponent />
      <span className={styles.title}>
        Ručni unos sati za osobni rad s grupom
      </span>
      <span className={styles.description}>
        Godina OR-a/eOR-a nosi 69 sati, RAR/eRAR nosi 21 sat, asistiranje na:
        Ljetnim IPD intenzivima i Modul uživo eOR-a: 25 sati, na Vikend
        intenzivima: 13 sati, fakultativnim radionicama: 3 sata, PRINT-ovima: 12
        sati. Obavezno oduzmi broj sati koji se odnosi na radionice na kojima
        nisi bio/bila.
      </span>
      <div className={styles.inputWrapper}>
        <div className={styles.inputColumn}>
          <span className={styles.label}>Vrsta radionice</span>
          <select
            className={styles.rucniUnosSelect}
            type="text"
            name="vrstaRadionicePrograma"
            value={formData.vrstaRadionicePrograma}
            onChange={(e) =>
              handleInputChange(
                "vrstaRadionicePrograma",
                e.target.value,
                setFormData,
                formData
              )
            }
          >
            <option value="" disabled>
              Odaberi
            </option>
            {osobniRadGrupeRadionice.map((item, index) => (
              <option key={index} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          {errors.vrstaRadionicePrograma && (
            <div className={styles.error}>{errors.vrstaRadionicePrograma}</div>
          )}
        </div>
        <div className={styles.inputColumn}>
          <span className={styles.label}>Uloga</span>
          <select
            className={styles.rucniUnosSelect}
            type="text"
            name="uloga"
            value={formData.uloga}
            onChange={(e) =>
              handleInputChange("uloga", e.target.value, setFormData, formData)
            }
          >
            <option value="" disabled>
              Odaberi
            </option>
            {uloge.map((item, index) => (
              <option key={index} value={item.label}>
                {item.label}
              </option>
            ))}
          </select>
          {errors.uloga && <div className={styles.error}>{errors.uloga}</div>}
        </div>
        <div className={styles.inputColumn}>
          <span className={styles.label}>
            Mjesec i godina održavanja ili školska godina OR-a/eOR-a
          </span>
          <input
            className={styles.rucniUnosInput}
            type="text"
            name="dateGrupa"
            placeholder="Upiši"
            value={formData.dateGrupa}
            onChange={(e) =>
              handleInputChange(
                "dateGrupa",
                e.target.value,
                setFormData,
                formData
              )
            }
          />
          {errors.dateGrupa && (
            <div className={styles.error}>{errors.dateGrupa}</div>
          )}
        </div>
        <div className={styles.inputColumn}>
          <span className={styles.label}>
            Ukupan broj sati radionice/programa
          </span>
          <input
            className={styles.rucniUnosInput}
            type="number"
            min="1"
            max="1000"
            name="brojSati"
            placeholder="Upiši"
            value={formData.brojSati}
            onChange={(e) =>
              handleInputChange(
                "brojSati",
                e.target.value,
                setFormData,
                formData
              )
            }
          />
          {errors.brojSati && (
            <div className={styles.error}>{errors.brojSati}</div>
          )}
        </div>
      </div>
      <div className={styles.btnRow}>
        <button
          onClick={() => {
            localStorage.setItem("evidentionFullName", fullName);
            localStorage.setItem("evidentionUserID", userEvidentionID);
            navigate("/evidencija");
          }}
          className={styles.cancelBtn}
        >
          Odustani
        </button>
        <button
          className={styles.successBtn}
          onClick={() =>
            handleUnesiSateClick(
              setErrors,
              formData,
              OsobniRadGrupaValidationSchema,
              userEvidentionID,
              "therapist_therapy_manual",
              otherInfo,
              authToken,
              setModalContent,
              navigate,
              setShowModal
            )
          }
        >
          Unesi sate
        </button>
      </div>
      {showModal && (
        <Modal
          image={modalContent.image}
          title={modalContent.description}
          buttons={modalContent.buttons}
        />
      )}
    </div>
  );
}

export default OsobniRadGrupa;
